module.exports = __webpack_public_path__ + "media/icons/naped-4x4-unactive@3x-6e831bab.svg";